import { createSelector } from "reselect";

export const usersSelector = createSelector(
    state => state.services.users,
    state => state
);
